import React from "react";
import styled from "styled-components";

import Button from "@material-ui/core/Button";

const PrimaryButton = props => <StyledButton {...props} />;

const StyledButton = styled(Button)`
  && {
    background-color: #1373ad;
    border-radius: 0 px;
    padding: 11px 27px;
    & > span {
      font-family: "Corisande Bold", Arial, Tahoma, sans-serif;
      font-size: 18px;
      font-weight: 500px;
    }
    &:hover {
      background-color: #0d4f78;
    }
  }
`;

export default PrimaryButton;
